import focusSource from 'ally.js/src/style/focus-source';

focusSource();



// WEBPACK FOOTER //
// ./project/client/src/core/utilities/ally.js.focusSource.js